import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

// Fetch all comments
export const fetchAllComments = createAsyncThunk(
  "comments/fetchAllComments",
  async (params = {}, { rejectWithValue }) => {
    try {
      // const token = localStorage.getItem("accessToken");
      // if (!token) throw new Error("No token found");

      const queryParams = new URLSearchParams();
      if (params.fields) queryParams.append("fields", params.fields);
      if (true) queryParams.append("sort", "-createdAt");
      if (params.search) queryParams.append("search", params.search);
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);

      const response = await axios.get(
        `${BASE_URL}/comment?${queryParams.toString()}`
      );
      // console.log(response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // return { data: [] };
        return { data: [], pagination: { count: 0, totalPages: 1 } };
      }
      return rejectWithValue(error.response?.data || "Failed to load comments");
    }
  }
);

// Fetch all comments(Admin)
export const fetchAllCommentsAdmin = createAsyncThunk(
  "comments/fetchAllCommentsAdmin",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const queryParams = new URLSearchParams();
      if (params.fields) queryParams.append("fields", params.fields);
      if (true) queryParams.append("sort", "-createdAt");
      if (params.search) queryParams.append("search", params.search);
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);

      const response = await axios.get(
        `${BASE_URL}/comment/admin?${queryParams.toString()}`,
        {
          headers: {
            token,
          },
        }
      );
      // console.log(response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // return { data: [] };
        return { data: [], pagination: { count: 0, totalPages: 1 } };
      }
      return rejectWithValue(error.response?.data || "Failed to load comments");
    }
  }
);

// Fetch single comment by ID
export const fetchCommentById = createAsyncThunk(
  "comments/fetchCommentById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/comment/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch comment");
    }
  }
);

// Add new comment
export const addComment = createAsyncThunk(
  "comments/addComment",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(data);
      const response = await axios.post(`${BASE_URL}/comment`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          token,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("addComment failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add comment");
    }
  }
);

// Add new comment By (Admin)
export const addCommentAdmin = createAsyncThunk(
  "comments/addCommentAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      // console.log(data);
      const response = await axios.post(`${BASE_URL}/comment/admin`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          token,
        },
      });

      return response.data.data;
    } catch (error) {
      console.error("addComment failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add comment");
    }
  }
);

// Update comment by ID
export const updateCommentById = createAsyncThunk(
  "comments/updateCommentById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // console.log({ id, data });
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.put(`${BASE_URL}/comment/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // 👈 مهم
          token,
        },
      });

      return response.data.data || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update comment"
      );
    }
  }
);

// Toggle comment active/inactive
export const toggleCommentStatus = createAsyncThunk(
  "comments/toggleCommentStatus",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.patch(
        `${BASE_URL}/comment/${id}/toggle`,
        null,
        { headers: { token } }
      );

      return response.data.data || { id };
    } catch (error) {
      console.error(
        "Toggle status failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to toggle comment status"
      );
    }
  }
);

// Delete comment
export const deleteComment = createAsyncThunk(
  "comments/deleteComment",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/comment/${id}`, {
        headers: { token },
      });

      return response.data.data || { id };
    } catch (error) {
      console.error(
        "Delete comment failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(
        error.response?.data || "Failed to delete comment"
      );
    }
  }
);

// Fetch single comment by ID
export const CommentIdToFeedback = createAsyncThunk(
  "comments/CommentIdToFeedback",
  async (id, { rejectWithValue }) => {
    const token = localStorage.getItem("accessToken");
    if (!token) throw new Error("No token found");

    // console.log(token);
    try {
      const response = await axios.post(
        `${BASE_URL}/comment/${id}/feedback`,
        null,
        {
          headers: {
            token,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch comment");
    }
  }
);

// Slice
const commentSlice = createSlice({
  name: "comments",
  initialState: {
    allComments: [],
    selectedComment: null,
    loading: false,
    error: null,
    commentCount: null,
    hasMorePages: null,
    totalPages: null,
  },
  reducers: {
    clearSelectedComment: (state) => {
      state.selectedComment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchAllComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllComments.fulfilled, (state, action) => {
        state.loading = false;
        state.allComments = action.payload.data;
        state.commentCount = action.payload.pagination.count;
        state.totalPages = action.payload.pagination.totalPages;
        state.hasMorePages = action.payload.pagination.hasMorePages;
      })
      .addCase(fetchAllComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // Fetch all (Admin)
      .addCase(fetchAllCommentsAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCommentsAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.allComments = action.payload.data;
        state.commentCount = action.payload.pagination.count;
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(fetchAllCommentsAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Fetch by ID
      .addCase(fetchCommentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommentById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedComment = action.payload;
      })
      .addCase(fetchCommentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Add
      .addCase(addComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.loading = false;
        state.allComments.push(action.payload);
      })
      .addCase(addComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Add Admin
      .addCase(addCommentAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCommentAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.allComments.push(action.payload);
      })
      .addCase(addCommentAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Update
      .addCase(updateCommentById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCommentById.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.allComments.findIndex(
          (comment) => comment._id === action.payload._id
        );
        if (index !== -1) {
          state.allComments[index] = action.payload;
        }
      })
      .addCase(updateCommentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Toggle status
      .addCase(toggleCommentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleCommentStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.allComments.findIndex(
          (comment) => comment._id === action.payload.id
        );
        if (index !== -1 && action.payload.status !== undefined) {
          state.allComments[index].status = action.payload.status;
        }
      })
      .addCase(toggleCommentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      // Delete
      .addCase(deleteComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteComment.fulfilled, (state, action) => {
        state.loading = false;
        state.allComments = state.allComments.filter(
          (comment) => comment._id !== action.payload.id
        );
      })
      .addCase(deleteComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearSelectedComment } = commentSlice.actions;
export default commentSlice.reducer;
